/**
 * @generated SignedSource<<5d80d84d7604b3dcb97dc1d25204afb4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingPaymentRaincheck_Raincheck$data = {
  readonly createdAt: string;
  readonly id: string;
  readonly squareGiftCard: {
    readonly balance: number;
    readonly id: string;
  };
  readonly " $fragmentType": "BookingPaymentRaincheck_Raincheck";
};
export type BookingPaymentRaincheck_Raincheck$key = {
  readonly " $data"?: BookingPaymentRaincheck_Raincheck$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingPaymentRaincheck_Raincheck">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingPaymentRaincheck_Raincheck",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareGiftCard",
      "kind": "LinkedField",
      "name": "squareGiftCard",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "balance",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Raincheck",
  "abstractKey": null
};
})();

(node as any).hash = "67b48245494efd3932af67b7fde109a9";

export default node;
